
export default {
  name: "PageLoader",
  props: {
    loading: Boolean,
  },
}
